import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Form, Container, Row, Col, Card } from "react-bootstrap";

const AddOfflineWallet = () => {
  // State to hold form data
  const [formData, setFormData] = useState({
    mobileNumber: "",
    dateWise: "",
    customDate: "",
  });

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle form submit (Search action)
  const handleSearch = (e) => {
    e.preventDefault();
    console.log("Searching with the following details:", formData);
    // Here, you can send data to a backend or perform the search logic
  };

  return (
    <Container fluid className="mt-5 px-5">
      <Row>
        <Col md={6} style={{ display: "flex", justifyContent: "flex-start" }}>
          <Card
            className="shadow-lg"
            style={{
              borderRadius: "12px", // Slightly rounded corners
              backgroundColor: "#f8f9fa",
              minWidth: "320px",
              width: "300px", // Decreased width to make it compact
              padding: "10px", // Small padding around the card
            }}
          >
            <Card.Body style={{ padding: "15px" }}> {/* Smaller padding inside the card body */}
              <h4
                className="mb-3"
                style={{
                  fontWeight: "300",
                  color: "#333",
                  textAlign: "left",
                }}
              >
                Add Offline Wallet
              </h4>
              <Form onSubmit={handleSearch}>
                <Row className="mb-3">
                  <Col md={12}>
                    <Form.Group controlId="formMobileNumber">
                      <Form.Label style={{ fontWeight: "500" }}>
                        Mobile Number
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter mobile number"
                        name="mobileNumber"
                        value={formData.mobileNumber}
                        onChange={handleInputChange}
                        required
                        className="border-1 rounded-lg"
                        style={{
                          borderColor: "#ced4da",
                          height: "45px", // Adjusted height for better visibility
                          fontSize: "14px",
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={12}>
                    <Form.Group controlId="formDateWise">
                      <Form.Label style={{ fontWeight: "500" }}>Date Wise</Form.Label>
                      <Form.Control
                        as="select"
                        name="dateWise"
                        value={formData.dateWise}
                        onChange={handleInputChange}
                        required
                        className="border-1 rounded-lg"
                        style={{
                          borderColor: "#ced4da",
                          height: "45px", // Adjusted height
                          fontSize: "14px",
                        }}
                      >
                        <option value="">Select Date</option>
                        <option value="Today">Today</option>
                        <option value="This Week">This Week</option>
                        <option value="This Month">This Month</option>
                        <option value="Custom Date">Custom Date</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>

                {/* Conditionally render the custom date picker if "Custom Date" is selected */}
                {formData.dateWise === "Custom Date" && (
                  <Row className="mb-3">
                    <Col md={12}>
                      <Form.Group controlId="formCustomDate">
                        <Form.Label style={{ fontWeight: "500" }}>Choose Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="customDate"
                          value={formData.customDate}
                          onChange={handleInputChange}
                          className="border-1 rounded-lg"
                          style={{
                            borderColor: "#ced4da",
                            height: "45px", // Adjusted height
                            fontSize: "14px",
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                )}

                <Row className="mb-3">
                  <Col md={12}>
                    <Button
                      variant="primary"
                      type="submit"
                      style={{
                        backgroundColor: "#007bff",
                        borderColor: "#007bff",
                        fontSize: "13px", // Slightly smaller font size
                        fontWeight: "500",
                        width: "100px", // Smaller width for button
                        height: "35px", // Smaller height for the button
                        borderRadius: "5px", // Rounded button
                        padding: "5px",  // Reduced padding
                        marginTop: "10px", // Small margin from top
                        marginLeft: "5px", // Small margin from left
                      }}
                    >
                      Search
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AddOfflineWallet;
